type Args = Parameters<typeof HTMLElement.prototype.scrollIntoView>[0];

export const scrollIntoViewAsync = (scrollContainer: Element, element: Element, args: Args, timeout = 5000) =>
  new Promise<void>((resolve, reject) => {
    // Check if the element is already in view
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          observer.disconnect();
          return resolve();
        }

        // If not in view, proceed with scrolling
        const timeoutId = setTimeout(() => {
          reject(new Error('Scrolling timed out'));
        }, timeout);

        scrollContainer.addEventListener(
          'scrollend',
          () => {
            clearTimeout(timeoutId);
            resolve();
          },
          { once: true },
        );

        element.scrollIntoView(args);
        observer.disconnect();
      },
      { root: scrollContainer },
    );

    element.scrollIntoView(args);
    observer.observe(element);
  });

export const isElementInViewport = (el: Element) => {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */ &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
};
